import React from 'react';
import { Typewriter } from 'react-simple-typewriter';
import { FaGithub, FaLinkedin, FaSteam, FaSpotify, FaFileAlt } from 'react-icons/fa';
import AnimatedLogo from './AnimatedLogo';
import SectionDivider from './SectionDivider';

export default function Hero() {
  return (
    <section id="hero" className="min-h-screen flex flex-col items-center justify-center text-center px-6">
            <AnimatedLogo />
      <h1 className="text-4xl md:text-5xl font-bold text-white">Hi, I'm Ali Fayed</h1>

      <h2 className="mt-4 text-xl md:text-2xl font-medium text-teal-400">
        <Typewriter
          words={[
            'Problem-Solving Enthusiast',
            'Full-stack Web Developer',
            'React & Tailwind Enthusiast',
            'UI/UX Explorer',
            'Accessibility & Performance Focused',
          ]}
          loop={true}
          cursor
          cursorStyle="|"
          typeSpeed={70}
          deleteSpeed={50}
          delaySpeed={1500}
        />
      </h2>

      <p className="mt-6 max-w-xl text-gray-400">
        I'm focused on building accessible and fast digital experiences using modern technologies.
      </p>
        <SectionDivider />
      {/* Social Icons */}
      <div className="flex space-x-4 mt-6 text-white text-2xl">
        <a href="https://github.com/3lifayed" target="_blank" rel="noopener noreferrer" className="hover:text-teal-400 transition">
          <FaGithub />
        </a>
        <a href="https://linkedin.com/in/3lifayed" target="_blank" rel="noopener noreferrer" className="hover:text-blue-400 transition">
          <FaLinkedin />
        </a>
        <a href="https://steamcommunity.com/id/its_smiley" target="_blank" rel="noopener noreferrer" className="hover:text-gray-400 transition">
          <FaSteam />
        </a>
        <a href="https://open.spotify.com/user/ha3li" target="_blank" rel="noopener noreferrer" className="hover:text-green-400 transition">
          <FaSpotify />
        </a>
        <a href="/files/Ali-Fayed-Resume-2026.pdf" target="_blank" rel="noopener noreferrer" className="hover:text-yellow-400 transition">
          <FaFileAlt />
        </a>
      </div>
    </section>
  );
}
